// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3zeB4","title":"BackImages_title__35yFj","images":"BackImages_images__VTJk1"};